import React from 'react';
import {FormattedMessage} from "react-intl";

import UserProfile from "./components/UserProfile";
import SidebarHeadingTitle from "../SidebarHeadingTitle";

function Profile(props) {
    return (
        <div style={{
            marginTop: '12px',
            marginBottom: '20px',
            paddingLeft: '12px',
            paddingRight: '12px'
        }}>
            <UserProfile />
        </div>
    );
}

export default Profile;
